"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package import
 */
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Router_1 = __importDefault(require("src/components/Router"));
const react_2 = require("@reduxjs/toolkit/dist/query/react");
/**
 * Local import
 */
const instances_1 = __importDefault(require("../store/apis/instances"));
const ToastContainer_1 = __importDefault(require("src/components/ToastContainer"));
/**
 * Component
 */
const App = () => (react_1.default.createElement(react_2.ApiProvider, { api: instances_1.default },
    react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
        react_1.default.createElement(Router_1.default, null),
        react_1.default.createElement(ToastContainer_1.default, { position: "top-center", hideProgressBar: true, icon: false }))));
exports.default = App;
